import request from '@/utils/request'
// 满减列表
export function reductionList(params) {
  return request({
    url: '/full/reductions',
    method: 'get',
    params
  })
}
// 添加满减
export function createReduction(data) {
  return request({
    url: '/full/reductions',
    method: 'post',
    data
  })
}
// 修改满减
export function updateReduction(data) {
  return request({
    url: '/full/reductions',
    method: 'put',
    data
  })
}
// 满减详情
export function reductionDetail(id) {
  return request({
    url: '/full/reductions/' + id,
    method: 'get'
  })
}
// 删除满减
export function deleteReduction(id) {
  return request({
    url: '/full/reductions/' + id,
    method: 'delete'
  })
}


// WEBPACK FOOTER //
// ./src/api/reduction.js